import type { TFunction } from 'i18next';
import type { ProductType } from '../../payment.types';

export const getThankYouTitle = (productType: ProductType, t: TFunction) => {
  switch (productType) {
    case 'TreasuryProductBattlePass':
      return t('Pass Unlocked');
    case 'TreasuryProductXPBooster':
      return t('Booster Applied');
    default:
      return t('Congratulations!');
  }
};
